import { defineStore } from 'pinia';
import axios from "axios";
import type {ApiCompanyCaen, ApiCompanyData} from "~/types/Customer";

export const useCompanyStore = defineStore('company', {
    state: () => ({
        _fetchCompanyDataPromise: null as Promise<ApiCompanyData> | null,
        companyCaenList: [] as ApiCompanyCaen[],
        _fetchCompanyCaenListPromise: null as Promise<ApiCompanyCaen[]> | null,
    }),
    actions: {
        async fetchCompanyData(cifCode: string, token?: string): Promise<ApiCompanyData> {
            console.info(cifCode);
            if (this._fetchCompanyDataPromise) return this._fetchCompanyDataPromise;

            this._fetchCompanyDataPromise = (async () => {
                try {
                    const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/v1/users/company-data`, {
                        cif_code: cifCode,
                        token: token,
                    });
                    if (response.data.data) {
                        // Ensure the returned data is a plain object
                        return JSON.parse(JSON.stringify(response.data.data)) as ApiCompanyData;
                    }
                    return {} as ApiCompanyData; // Return an empty object if no data
                } catch (error) {
                    throw error;
                } finally {
                    this._fetchCompanyDataPromise = null;
                }
            })();

            return this._fetchCompanyDataPromise;
        },
        async fetchCompanyCaenList(): Promise<ApiCompanyCaen[]> {
            if (this._fetchCompanyCaenListPromise) return this._fetchCompanyCaenListPromise;

            this._fetchCompanyCaenListPromise = (async () => {
                try {
                    const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v1/company-caens`);
                    if (response.data.data) {
                        // Ensure the returned data is a plain object
                        return JSON.parse(JSON.stringify(response.data.data)) as ApiCompanyCaen[];
                    }
                    return [] as ApiCompanyCaen[]; // Return an empty array if no data
                } catch (error) {
                    throw error;
                } finally {
                    this._fetchCompanyCaenListPromise = null;
                }
            })();

            return this._fetchCompanyCaenListPromise;
        },
        async getCompanyCaenList(): Promise<ApiCompanyCaen[]> {
            if (this.companyCaenList.length === 0) {
                this.companyCaenList = await this.fetchCompanyCaenList();
            }
            return this.companyCaenList;
        }
    },
});